import React, { useEffect, useState} from "react";
import withMatchMediaProps from "@hocs/with-match-media-props";
import PropTypes from "prop-types";

const PDFViewer = ({ pdfUrl, size, scale, isNarrowScreen}) => {
  const PDFJS = window.pdfjsLib;
  const [pdf, setPdf] = React.useState(null);
  const [image, setImage] = React.useState(null);

  const [pdfRendering, setPdfRendering] = React.useState("");

  async function showPdf() {
    try {
      setPdfRendering(true);
      const pdfDoc = await PDFJS.getDocument({ url: pdfUrl });
      setPdf(pdfDoc);
      setPdfRendering(false);
    } catch (error) {
      alert(error.message);
    }
  }

  async function renderPage() {
    const canvas = document.createElement("canvas");
    canvas.setAttribute("className", "canv");

    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1 });
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    await page.render({
      canvasContext: canvas.getContext("2d"),
      viewport: viewport,
    }).promise;
    let img = canvas.toDataURL("image/png");
    setImage(img);
  }

  useEffect(() => {
    showPdf();
  }, []);

  useEffect(() => {
    pdf && renderPage();
  }, [pdf]);

  return (
    <div id="pdf-main-container">
      <div id="pdf-loader" hidden={!pdfRendering}>
        Loading ...
      </div>
      <div id="pdf-contents">
        <img
          id="image-generated"
          src={image}
          alt="pdfImage"
          style={
            size == "small"
              ? {
                  width: isNarrowScreen ? "110px" : "220px",
                  height: isNarrowScreen ? "160px" : "254px",
                  transform: `scale(${scale})`,
                }
              : {
                transform: `scale(${scale})`,
              }
          }
        />
      </div>
    </div>
  );
};

PDFViewer.propTypes = {
  pdfUrl: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  scale: PropTypes.number.isRequired,
  isNarrowScreen: PropTypes.bool.isRequired,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(PDFViewer);


// WEBPACK FOOTER //
// ./components/claim/PDFViewer.js